import { channelTypeFromString } from "../../../src/models/ChannelType";
import { useOnChangeWatcher } from "../../../src/models/useOnChangeWatcher";
import { itx } from "../../../src/translationItx/itx";
import { C1_ELO_PLUG_TYPE_LABELS } from "../C1_uiLabels";
import type { C1_Consumer } from "../model/C1_Consumer";

/** Socket type is the consumer's native channel, never a second value in an ELO tree snapshot. */
export function C1_SocketTypeSelect({ item, options }: { item: C1_Consumer; options: readonly string[] }) {
  useOnChangeWatcher(item.owner);
  return <select
    className="C1_EloDetailSelect dockControl"
    aria-label={itx("c1.ui.Steckdosentyp", "Steckdosentyp")}
    value={item.channelType}
    onChange={(event) => state.undoManager.runAsSingleStep(
      itx("c1.ui.Steckdosentyp_andern", "Steckdosentyp ändern"),
      () => item.setChannelType(channelTypeFromString(event.target.value)),
    )}
  >
    {options.map(option => <option key={option} value={option}>{C1_ELO_PLUG_TYPE_LABELS[option] ?? option}</option>)}
  </select>;
}
